import { boolean, number, object, string } from 'yup'

const ToyotaChrSchema = object().shape({
  title: string()
    .required('Title is required')
    .min(1, 'Title must be at least 2 characters')
    .max(10, 'Title must be at most 10 characters')
    .trim(),
  first_name: string()
    .required('First name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,30}$/,
      'First name can only contain letters and basic punctuation',
    )
    .min(2, 'First name must be at least 2 characters')
    .max(30, 'First name must be at most 30 characters')
    .trim(),
  last_name: string()
    .required('Last name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,30}$/,
      'Last name can only contain letters and basic punctuation',
    )
    .min(2, 'Last name must be at least 2 characters')
    .max(30, 'Last name must be at most 30 characters')
    .trim(),
  email: string()
    .required('Email is required')
    .matches(
      /^([a-z0-9]+(?:[._-][a-z0-9]+)*)@([a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,})$/,
      'Email must be a valid email address',
    )
    .max(255)
    .trim(),
  tel: string()
    .required('Phone is required')
    .matches(/^\d{7,11}$/, {
      message: 'Please enter a valid telephone number',
      excludeEmptyString: true,
    })
    .trim(),
  type: string(),
  notes: string(),
  grade: string().required('Please select an option').trim(),
  powertrain: string().required('Please select an option').trim(),
  model: string().required('Please select an option').trim(),
  response_code: string().uppercase().trim(),
  campaign_response_code: string().uppercase().trim(),
  campaign_code: string().uppercase().trim(),
  dealer: number(),
  dealer_name: string().trim(),
  consent: object({
    user: boolean(),
  }),
})

export default ToyotaChrSchema
